import Datepicker from '@vuepic/vue-datepicker';
import Icon from '🔗/components/ui/Icon.vue';

import { vTooltip } from '🔗/utils/directives/tooltip.js'
import vDragScroll from '🔗/utils/directives/drag-scroll';
import vContextMenu from '🔗/utils/directives/context-menu';

import axios from 'axios';
import Vue3TouchEvents from "vue3-touch-events";
import { createApp } from 'vue';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';
import App from './App.vue';
import router from './router';
import { fetchData, message } from '🔗/utils/utils';
import { createPinia } from 'pinia';

// import stores from '@/stores';

import '🔗/assets/scss/base.scss';
import '@/assets/scss/base.scss';
import '@vuepic/vue-datepicker/dist/main.css';

if (import.meta.env.VITE_APP_TITLE) {
    document.title = import.meta.env.VITE_APP_TITLE;
}

export const app = createApp(App);

app.use(router);
router.app = app;

// Pinia
const pinia = createPinia();
pinia.use(({ options, store }) => {
    store.$http = fetchData;
    store.$message = message;

    // Если в настройках стора передано поле watch
    if (options.watch) {
        Object.keys(options.watch).forEach((getterKey) => {
            const handler = options.watch[getterKey];

            // Запускаем реактивный watch из Vue, привязанный к контексту стора
            watch(
                () => store[getterKey], // Следим за геттером или стейтом
                (newValue, oldValue) => {
                    // Вызываем обработчик, привязывая его к `this` стора
                    handler.call(store, newValue, oldValue);
                }
            );
        });
    }
});

app.use(pinia);
app.use(Vue3TouchEvents);
app.use(VueAxios, axios);
app.use(VueCookies);
app.use(stores.locale().create());

app.component('Datepicker', Datepicker);
app.component('Icon', Icon);

app.directive('tooltip', vTooltip);
app.directive('scroll', {
    inserted: function (el, binding) {
        let f = function (evt) {
            if (binding.value(evt, el)) {
                window.removeEventListener('scroll', f);
            }
        };
        window.addEventListener('scroll', f);
    }
});

app.directive('drag-scroll', vDragScroll);
app.directive('context-menu', vContextMenu);

app.config.globalProperties.$http = fetchData;
app.config.globalProperties.$message = message;

app.mount('#studio-app');
